<template>
  <div class="container">
    <h5>报名信息</h5>
    <div class="cont">
      <section>
        <div class="field">
          <p>报名类型：<span>*</span></p>
          <div style="1px solid #cfcfcf">
            <!-- <el-select v-model="user.sign_type" placeholder="请选择您的报名类型" @change="selectType">
              <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select> -->
            <el-radio-group v-model="user.sign_type" @change="selectType">
              <el-radio v-for="item in options2" :key="item.value" :label="item.value" :value="item.value">{{item.label}}</el-radio>
            </el-radio-group>
            <!--  1 别人 0 自己 -->
          </div>
        </div>
        <div class="field">
          <p>姓名：<span>*</span></p>
          <input type="text" placeholder="请输入真实姓名" :disabled="disabled" v-model="user.name">
        </div>
        <div class="field">
          <p>身份证号：<span>*</span></p>
          <input type="text" placeholder="请输入您的身份证号" :disabled="disabled" v-model="user.idcard">
        </div>
        <div class="field">
          <p>手机号：<span>*</span></p>
          <input type="text" placeholder="请输入手机号" v-model="user.tel">
        </div>
        <!-- <div class="field">
          <p>年龄：<span>*</span></p>
          <input type="number" placeholder="请输入您的年龄" v-model="user.age">
        </div>
        <div class="field">
          <p>性别：<span>*</span></p>
          <input type="radio" value="男" v-model="user.gender" /><span style="color: #a3a3a3;margin: 0 10px;">男</span>
          <input type="radio" value="女" v-model="user.gender" /><span style="color: #a3a3a3;margin-left: 10px;">女</span>
        </div> -->
        <div class="field">
          <p>所属街道：<span>*</span></p>
          <!-- <input type="text" placeholder="请输入您的家庭地址" v-model="user.address" /> -->
          <div style="1px solid #cfcfcf">
            <!-- <select name="" v-model="user.address" placeholder="请选择您的所属街道">
              <option :value="child" v-for="child in options">
                {{child}}
              </option>
            </select> -->
            <el-select v-model="user.address" placeholder="请选择所属街道">
              <el-option v-for="item in options" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </div>
        </div>
        <!--<div class="field" v-if="uploadFlag || user.sign_type == 1">
          <p>上传身份证：<span>*</span></p>
          <div class="idcard">
            <p>
              <input id="i2" name="i2" type="file" accept="image/*" ref="file" @change="upload($event,'front')">
              <a v-if="!user.idcard_front">身份证正面</a>
              <img :src="user.idcard_front" alt="" v-if="!!user.idcard_front">
            </p>
             <p>
              <input id="i3" name="i3" type="file" accept="image/*" ref="file" @change="upload($event,'backend')">
              <a v-if="!user.idcard_reverse">身份证反面</a>
              <img :src="user.idcard_reverse" alt="" v-if="!!user.idcard_reverse">
            </p> 
          </div>
        </div>-->
        <div class="btn btn-primary" @click="submit">报名</div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['ajax'],
  data() {
    return {
      user: {},
      flag: true,
      options: [
        '八大关街道',
        '八大湖街道',
        '八大峡街道',
        '江苏路街道',
        '金门路街道',
        '金湖路街道',
        '香港中路街道',
        '云南路街道',
        '湛山街道',
        '中山路街道',
        '珠海路街道'
      ],
      options2: [
        {
          label: '自己报名',
          value: 0
        }, {
          label: '给别人报名',
          value: 1
        }
      ],
      disabled: false
    };
  },
  computed: {

  },
  created() {

  },
  mounted() {
    this.ajax('/api/course/signForUserInfo', 'get', '', res => {
      if (Object.keys(res.data.data) == 0) {
        this.user = {
          name: '',
          tel: '',
          idcard: '',
          idcard_front: '',
          sign_type: 0,
        }

      } else {
        this.disabled = true
        this.user = res.data.data
        this.user.sign_type = 0
      }
    })
  },
  watch: {

  },
  methods: {
    selectType() {
      console.log(this.user.sign_type)
      let _this = this
      if (this.user.sign_type == 0) {
        this.getUserInfo()
      } else {
        this.disabled = false
        this.user = {
          sign_type: _this.user.sign_type,
          name: '',
          tel: '',
          idcard_front: '',
          address: ''
        }
      }
    },
    getUserInfo() {
      let _this = this
      var sign_type = this.user.sign_type
      this.ajax('/api/course/signForUserInfo', 'get', '', res => {
        if (Object.keys(res.data.data) == 0) {
          console.log(sign_type)
          this.user = {
            name: '',
            tel: '',
            idcard: '',
            idcard_front: '',
            sign_type: _this.user.sign_type,
          }
        } else {
          this.disabled = true
          this.user = res.data.data
          this.user.sign_type = sign_type
        }
      })
    },
    // 报名
    submit() {
      if (this.flag) {
        let id = this.$route.query.id
        let params = {
          name: this.user.name,
          idcard: this.user.idcard,
          sign_type: this.user.sign_type,
          phone: this.user.tel,
          id: id,
          address: this.user.address
        }
        // delete params.tel
        this.ajax('/api/course/addSign', 'post', this.$qs.stringify(params), res => {
          if (res.data.errcode == 0) {
            this.$alert('报名成功', () => {
              this.$router.go(-1)
            })
          } else {
            this.$toast(res.data.errmsg)
            params.tel = params.phone
            let data = Object.keys(params)
            this.user = data
          }

        })
      } else {
        this.$toast('信息有误')
      }

    },
    // 上传图片
    upload(e, type) {
      let that = this
      let img = e.target.files[0];
      let param = new FormData()
      param.append('file', img)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$loading.show()
      if (type == "team") {
        this.axios.post('/api/user/image', param, config)
          .then(res => {
            if (res.data.errcode == 0) {
              that.user.team_pic = res.data.data.url
              that.$nextTick(() => {

                that.$loading.hide()
                that.$toast('上传成功')
              })
            } else {
              that.$toast(res.data.errmsg)
            }
          })
      } else {
        this.axios.post('/api/user/idcard', param, config)
          .then(res => {
            if (res.data.errcode == 0) {
              // that.$toast('上传成功')

              that.axios.post('/api/course/realnameVerify', this.$qs.stringify({
                img_url: res.data.data.url
              })).then(result => {
                if (result.data.errcode == 0) {
                  that.user.idcard_front = res.data.data.url
                  that.flag = true
                  that.$nextTick(() => {
                    that.$loading.hide()
                    that.$toast('上传成功')
                  })
                } else {
                  that.$loading.hide()
                  this.$toast(result.data.errmsg)
                }

              })
            } else {
              that.$toast(res.data.errmsg)
            }
          })
      }

    },
  },
  components: {

  },
};
</script>
<style>
input[disabled],
input:disabled,
input.disabled {
  color: #999;
  -webkit-text-fill-color: #999;
  -webkit-opacity: 1;
  opacity: 1;
}
.el-input--suffix .el-input__inner {
  color: #a3a3a3;
  border: 1px solid #cfcfcf;
  font-size: 1em;
  height: 45px;
  line-height: 45px;
  font-size: 16px;
}
.el-select {
  width: 100%;
}
.el-scrollbar__wrap {
  margin-bottom: 0 !important;
}
@media only screen and (max-width: 750px) {
  .el-input--suffix .el-input__inner {
    color: #a3a3a3;
    border: 1px solid #cfcfcf;
    height: 0.35rem;
    line-height: 0.35rem;
    font-size: 1em;
  }
}
</style>
<style scoped>
.container {
  background: #fff;
  padding: 50px;
}

.container > h5 {
  font-size: 1.3em;
  color: #333333;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eeeeee;
}

.cont {
  width: 36.3em;
  margin: 20px auto;
}

.cont > h6 {
  font-size: 1em;
  color: #333;
  font-weight: bold;
  text-align: center;
}

.cont > h6 > span {
  color: #0677e4;
  font-style: italic;
}

.cont > section {
  padding: 20px 74px 0;
}

.cont .btn {
  width: 100%;
  line-height: 45px;
  height: 45px;
}

.field {
  min-height: 60px;
  padding: 5px 0;
}

.field input[type="text"],
.field input[type="number"] {
  font-size: 1em;
  border: 1px solid #cfcfcf;
  width: 100%;
  line-height: 45px;
  padding: 5px 10px;
  border-radius: 7px;
  height: 45px;
  outline: none;
  color: #a3a3a3;
}

.field p {
  color: #666666;
  font-size: 0.9em;
  margin-bottom: 5px;
}

.field p > span {
  color: red;
}

.field > label {
  font-size: 0.8em;
  color: #b2b2b2;
}

.blue {
  color: #42adff;
}

.idcard {
  display: flex;
  justify-content: space-between;
}

.idcard p {
  color: #999;
  width: 47%;
  height: 140px;
  border-radius: 7px;
  border: 1px solid #cfcfcf;
  color: #aaaaaa;
  text-align: center;
  line-height: 140px;
  font-size: 1.1em;
  position: relative;
  overflow: hidden;
}

.idcard p img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

input[type="file"] {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
}

.btn {
  margin-top: 15px;
}

@media only screen and (max-width: 750px) {
  .container > h5 {
    font-size: 1em;
    padding-bottom: 0.1rem;
  }

  .cont .item {
    width: 100%;
  }

  .container {
    padding: 0.15rem;
    font-size: 0.14rem;
  }

  .cont {
    width: 100%;
  }

  .cont > section {
    padding: 0 0.15rem;
  }

  .field input[type="text"],
  .field input[type="number"] {
    height: 0.35rem;
    line-height: 0.35rem;
  }

  .idcard p {
    height: 0.8rem;
    line-height: 0.8rem;
    overflow: hidden;
  }
}
</style>